import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useAppSelector } from '../../../hooks';
import { selectNexaTransmitters } from '../../../reducers/nexaTransmittersSlice';
import { ConfigNexaTransmitterRow } from './ConfigNexaTransmitterRow';
import { DialogNexaTransmitterEdit } from './DialogNexaTransmitterEdit';
export const ConfigNexaTransmitters = (_props) => {
    const transmittersMap = useAppSelector(selectNexaTransmitters);
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [id, setId] = useState('new');
    const edit = (id) => { setId(id); setEditDialogVisible(true); };
    const newTransmitter = () => { setId('new'); setEditDialogVisible(true); };
    const transmitters = Object.values(transmittersMap).sort((a, b) => a.title.localeCompare(b.title));
    const rows = [];
    if (transmitters) {
        for (const t of transmitters) {
            rows.push(_jsx(ConfigNexaTransmitterRow, { id: t.id, editHandler: edit }, t.id));
        }
    }
    return (_jsxs("div", { className: "page-container", children: [_jsx("h2", { children: "Nexa-s\u00E4ndare" }), _jsx(DialogNexaTransmitterEdit, { isOpen: editDialogVisible, id: id, onClose: () => setEditDialogVisible(false) }, 'id'), _jsx("div", { className: "operations", children: _jsx("button", { className: "lw success", onClick: () => newTransmitter(), children: "\u00A0L\u00E4gg till s\u00E4ndare...\u00A0" }) }), _jsx("div", { className: "config-rows config-transmitters", children: rows })] }));
};
